import SectionHeading from "@/pages/home/components/SectionHeading";
import { chapters } from "@/mocks/homeContent";

export default function ContentGuide() {
  return (
    <section id="chapters" className="scroll-mt-24 bg-background-50">
      <div className="mx-auto max-w-[1200px] px-4 py-14 md:px-6 md:py-20">
        <SectionHeading
          eyebrow="内容结构"
          title="从开场到收束的五个阶段"
          desc="作品按情绪推进划分为若干阶段。了解结构有助于在观看完整版时把握节奏，也方便对照理解人物关系的变化。"
        />

        {/* 桌面端横向阶段条 */}
        <div className="mt-12 hidden lg:block">
          <div className="relative">
            <div className="absolute left-0 right-0 top-6 h-px bg-background-300" aria-hidden="true" />
            <div className="relative grid grid-cols-5 gap-5">
              {chapters.map((ch) => (
                <div key={ch.index} className="flex flex-col items-center text-center">
                  <span className="flex h-12 w-12 items-center justify-center rounded-full border-4 border-background-50 bg-primary-500 font-heading text-sm font-bold text-background-50">
                    {ch.index}
                  </span>
                  <span className="mt-4 rounded-full bg-accent-100 px-2.5 py-0.5 text-xs text-accent-800">
                    {ch.badge}
                  </span>
                  <h3 className="mt-3 font-heading text-sm font-semibold text-foreground-950">
                    {ch.title}
                  </h3>
                  <p className="mt-2 text-xs leading-relaxed text-foreground-600">
                    {ch.desc}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* 移动端纵向时间线 */}
        <ol className="mt-10 space-y-4 lg:hidden">
          {chapters.map((ch) => (
            <li
              key={ch.index}
              className="flex gap-4 rounded-lg border border-background-200 bg-background-100 p-4"
            >
              <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-primary-500 font-heading text-sm font-bold text-background-50">
                {ch.index}
              </span>
              <div className="min-w-0">
                <div className="flex flex-wrap items-center gap-2">
                  <h3 className="font-heading text-sm font-semibold text-foreground-950">
                    {ch.title}
                  </h3>
                  <span className="rounded-full bg-accent-100 px-2 py-0.5 text-xs text-accent-800">
                    {ch.badge}
                  </span>
                </div>
                <p className="mt-1.5 text-sm leading-relaxed text-foreground-600">
                  {ch.desc}
                </p>
              </div>
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
}